import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { Card } from "@/components/ui/card";
import { useEffectivePermissions, useHasPermission } from "@/lib/auth/permissions";

export function MaintenanceGuard() {
  const { t } = useTranslation();
  const { isLoading: permsLoading } = useEffectivePermissions();
  const hasRead = useHasPermission("maintenance.asset.read");
  const hasManage = useHasPermission("maintenance.asset.manage");
  const canView = hasRead || hasManage;

  if (permsLoading) return null;

  if (!canView) {
    return (
      <div className="p-6 max-w-6xl mx-auto">
        <Card className="text-sm text-ink-500 p-6">{t("rbac.noAccess")}</Card>
      </div>
    );
  }

  return <Outlet />;
}
